import request from "@/utils/request";
import { ouchnCustom } from "@/service";

// 在线阅读epub——添加笔记
export function insertNote(data) {
  return request({
    url: ouchnCustom + "/web/api/note/addNote",
    method: "post",
    data: data,
    header: {
      token: true,
    },
  });
}
// 在线阅读epub——修改笔记
export function update(data) {
  return request({
    url: ouchnCustom + "/web/api/note/updateNote",
    method: "post",
    data: data,
    header: {
      token: true,
    },
  });
}
// 在线阅读epub——删除笔记
export function removeNoteById(noteId) {
  return request({
    url: ouchnCustom + "/web/api/note/deleteNote",
    method: "post",
    params: { noteId },
    header: {
      token: true,
    },
  });
}
// 根据资源文件id查询所有笔记
export function selectNoteListByFileId(filesId) {
  return request({
    url: ouchnCustom + "/web/api/note/getNoteInfo",
    method: "get",
    params: { filesId },
    header: {
      token: true,
    },
  });
}
// 查看阅读文件地址和文件进度
export function selectFileLinkAndReadingLocation(data) {
  return request({
    url: ouchnCustom + "/web/read/selectFileLinkAndReadingLocation",
    method: "post",
    data: data,
    header: {
      token: true,
    },
  });
}
// 获取阅读时长
export function selectReadInfo(params) {
  return request({
    url: ouchnCustom + "/web/read/selectReadInfo",
    method: "get",
    params: params,
    header: {
      token: true,
    },
  });
}
// 获取调用阅读时长接口频率
export function selectTimeParameter(params) {
  return request({
    url: ouchnCustom + "/web/read/selectTimeParameter",
    method: "get",
    params: params,
    header: {
      token: true,
    },
  });
}
// 更新用户阅读时长
export function updateOcDownloadReading(data) {
  return request({
    url: ouchnCustom + "/web/read/updateOcDownloadReading",
    method: "post",
    data: data,
    header: {
      token: true,
    },
  });
}
// 更新阅读进度
export function updateOcReadSchedule(data) {
  return request({
    url: ouchnCustom + "/web/read/updateOcReadSchedule",
    method: "post",
    data: data,
    header: {
      token: true,
    },
  });
}
// 获取转换后的图片路径（pdf在线阅读）
export function getConvertImagePath(params) {
  return request({
    url: ouchnCustom + "/web/read/getConvertImagePath",
    method: "get",
    params: params,
    header: {
      token: true,
    },
  });
}
// 添加书签
export function addBookMark(data) {
  return request({
    url: ouchnCustom + "/device/api/bookMark/addBookMark",
    method: "post",
    data: data,
    header: {
      token: true,
    },
  });
}
// 获取书签
export function selectBookMarkList(params) {
  return request({
    url: ouchnCustom + "/device/api/bookMark/selectBookMarkList",
    method: "get",
    params: params,
    header: {
      token: true,
    },
  });
}
// 获取扫码资源信息
export function GetSource(codeId) {
  return request({
    url: ouchnCustom + "/getSource?codeId=" + codeId,
    method: "get",
  });
}

// 扫描在线扫码项目二维码后进入的跳转接口
export function transOnlineProjectCode(id, isApp) {
  return request({
    url: ouchnCustom + "/transOnlineProjectCode/" + id + isApp,
    method: "get",
  });
}

// 获取在线扫码项目下的资源
export function getOnlineCodeResource(onlineCodeId) {
  return request({
    url: ouchnCustom + "/getOnlineCodeResource/" + onlineCodeId,
    method: "get",
  });
}

// 通过在线扫码项目二维码进入的资源添加扫码记录
export function onlineResourceId(
  onlineResourceId,
  remoteAddr,
  userAgent,
  userName
) {
  return request({
    url:
      ouchnCustom +
      "/onlineResourceId/" +
      onlineResourceId +
      "?remoteAddr=" +
      remoteAddr +
      "&userAgent=" +
      userAgent +
      "&userName=" +
      userName,
    method: "get",
  });
}

// 获取某个章节的活页信息
export function getCatalogInfoById(params) {
  return request({
    url:
      ouchnCustom +
      "/foreign/interface/getCatalogInfoById?catalogId=" +
      params.catalogId+'&type='+params.type,
    method: "get",
    // params: params,
    // header: {
    //   token: true,
    // },
  });
}
